import React from "react";
import styles from "@/components/telemetry/common/MethodBadge.module.css";

interface MethodBadgeProps {
  method: string;
}

function getMethodClass(method: string): string {
  switch (method.toUpperCase()) {
    case "GET":
      return styles.get ?? "";
    case "POST":
      return styles.post ?? "";
    case "PUT":
    case "PATCH":
      return styles.put ?? "";
    case "DELETE":
      return styles.delete ?? "";
    default:
      return styles.other ?? "";
  }
}

function MethodBadge({ method }: MethodBadgeProps) {
  return (
    <span className={`${styles.badge ?? ""} ${getMethodClass(method)}`}>
      {method.toUpperCase()}
    </span>
  );
}

export default MethodBadge;
